module.exports = __webpack_public_path__ + "static/media/sachin.e50f49ae.png";